import {setConfigDgTable} from "@datagrupo2/dg-ng-util";

export const configLocalDgTable: setConfigDgTable = {
  typeShowActions: 'inline-name',
  headerNameActions: '',
}
